import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#e5e7eb] bg-[#24303F] overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 pt-10 md:pt-14 pb-8">
        {/* Brand wordmark lockup */}
        <div>
          <img
            src="/wordmark-light.png"
            alt="RideMate"
            width="1000"
            height="200"
            data-testid="footer-wordmark"
            className="w-[62vw] max-w-[520px] md:w-[420px] h-auto select-none"
            draggable={false}
          />
        </div>

        <div className="mt-8 grid md:grid-cols-12 gap-10 border-t border-white/10 pt-8">
          <div className="md:col-span-5">
            <p className="font-body text-white/70 text-base max-w-md leading-relaxed">
              India's flexible ride-pooling app — where the line between
              co-traveller and trip host disappears in 10 minutes.
            </p>
            <div className="mt-6 flex gap-3">
              <Social icon={Instagram} href="https://www.instagram.com/ridemate_app" label="instagram" />
              <Social icon={Facebook} href="https://www.facebook.com/share/1861ydn8bE/?mibextid=wwXIfr" label="facebook" />
              <Social icon={Mail} href="/contact" label="email" isLink />
            </div>
          </div>

          <FooterCol
            title="Product"
            items={[
              { label: "Features", href: "/#features" },
              { label: "How it works", href: "/#how-it-works" },
              { label: "Download", href: "/#download" },
              { label: "FAQ", href: "/#faq" },
            ]}
          />
          <FooterCol
            title="Company"
            items={[
              { label: "About Us", href: "/about", isLink: true },
              { label: "Contact", href: "/contact", isLink: true },
              { label: "Careers", href: "/contact", isLink: true },
            ]}
          />
          <FooterCol
            title="Legal"
            items={[
              { label: "Privacy", href: "/privacy", isLink: true },
              { label: "Safety", href: "/safety", isLink: true },
              { label: "Terms of Service", href: "/terms", isLink: true },
              { label: "Refund & Cancellation", href: "/refunds", isLink: true },
            ]}
          />
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="font-body text-xs text-white/55">
            © {new Date().getFullYear()} RideMate · Made in India ·
            All rights reserved.
          </div>
          <div className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
            Coming Soon · Pre-launch
          </div>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, items }) => (
  <div className="md:col-span-2">
    <div className="font-display text-[11px] uppercase tracking-[0.25em] text-white/50 font-bold">
      {title}
    </div>
    <ul className="mt-5 space-y-3">
      {items.map((it) => (
        <li key={it.label}>
          {it.isLink ? (
            <Link
              to={it.href}
              data-testid={`footer-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-body text-[15px] text-white/80 hover:text-[#5FA836] transition-colors"
            >
              {it.label}
            </Link>
          ) : (
            <a
              href={it.href}
              data-testid={`footer-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-body text-[15px] text-white/80 hover:text-[#5FA836] transition-colors"
            >
              {it.label}
            </a>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const Social = ({ icon: Icon, href, label, isLink }) => {
  const className =
    "h-9 w-9 rounded-full border border-white/20 grid place-items-center text-white/80 hover:text-[#5FA836] hover:border-[#5FA836]/60 transition-colors";
  if (isLink) {
    return (
      <Link to={href} data-testid={`social-${label}`} className={className}>
        <Icon className="w-4 h-4" />
      </Link>
    );
  }
  return (
    <a href={href} data-testid={`social-${label}`} className={className} target="_blank" rel="noopener noreferrer">
      <Icon className="w-4 h-4" />
    </a>
  );
};
